import { render, staticRenderFns } from "./AdminAdsSection.vue?vue&type=template&id=b168c4b8&scoped=true"
import script from "./AdminAdsSection.vue?vue&type=script&lang=js"
export * from "./AdminAdsSection.vue?vue&type=script&lang=js"
import style0 from "./AdminAdsSection.vue?vue&type=style&index=0&id=b168c4b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b168c4b8",
  null
  
)

export default component.exports